export default function TopicsSection() {
  const topics = [
    { name: '#庆余年2大结局', hot: '128万讨论', trend: 'up' },
    { name: '#繁花胡歌唐嫣', hot: '96万讨论', trend: 'up' },
    { name: '#流浪地球3上映', hot: '85万讨论', trend: 'hot' },
    { name: '#狂飙未删减版', hot: '73万讨论', trend: 'up' },
    { name: '#咒术回战最终章', hot: '68万讨论', trend: 'hot' },
    { name: '#三体网飞对比', hot: '52万讨论', trend: 'up' },
    { name: '#黑暗荣耀金恩淑', hot: '47万讨论', trend: 'up' },
    { name: '#凡人修仙传动漫', hot: '41万讨论', trend: 'new' },
    { name: '#怪奇物语第五季', hot: '38万讨论', trend: 'hot' },
    { name: '#长相思第二季', hot: '35万讨论', trend: 'new' },
  ];

  const getTrendIcon = (trend: string) => {
    if (trend === 'hot') return 'ri-fire-fill text-red-400';
    if (trend === 'new') return 'ri-sparkling-fill text-amber-400';
    return 'ri-arrow-up-circle-fill text-emerald-400';
  };

  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热议话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            追剧社区最热讨论，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group inline-flex items-center gap-2.5 px-4 py-3 bg-background-100 border border-background-200/50 rounded-xl cursor-pointer hover:border-accent-500/30 hover:bg-background-200 transition-all duration-200"
            >
              <span className="text-sm font-medium text-foreground-200 whitespace-nowrap group-hover:text-foreground-50 transition-colors">
                {topic.name}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                <i className={getTrendIcon(topic.trend) + ' text-xs'}></i>
                {topic.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}